import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import axios from 'axios'
import Vant from 'vant'
import 'vant/lib/index.css'

// 创建Vue应用实例
const app = createApp(App)

// 配置axios
axios.defaults.baseURL = '/'
axios.defaults.timeout = 10000

// 使用插件
app.use(router)
app.use(createPinia())
app.use(Vant)

// 挂载应用
app.mount('#app')
